// extracted by mini-css-extract-plugin
export var pillWrapper = "_po-0";
export var showOverflow = "_po-1";